import { useSportContext } from '@sorare/core/src/contexts/sport';
import { WatchlistsPage as WatchlistsPageComponent } from '@sorare/marketplace/src/components/watchlists/WatchlistsPage';

const WatchlistsPage = () => {
  const { sport } = useSportContext();
  return <WatchlistsPageComponent sport={sport} />;
};

export default WatchlistsPage;
